module.exports = __webpack_public_path__ + "static/media/loading.5e58d8a0.svg";